document.querySelectorAll(".collection-qty-change").forEach(function (button) {
  button.addEventListener("click", function () {
    const input = this.parentElement.querySelector(".quantity-input");
    let currentVal = parseInt(input.value, 10);

    if (this.dataset.quantityAction === "increase") {
      input.value = currentVal + 1;
    } else if (this.dataset.quantityAction === "decrease" && currentVal > 1) {
      input.value = currentVal - 1;
    }
  });
});
